import Collapse from 'antd/es/collapse';
import styled, { css } from 'styled-components';
import { media } from '../../../theme/mixins/responsive';
import Typography from '../../common/typography';
import { LargeBodyTheme, SmallBodyTheme } from './grant-card-body';
export const GrantCardHeaderContainer = styled.div `
  display: flex;
  background: ${({ theme }) => theme.colors.beige_2};

  position: relative;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}px) {
    flex-direction: column;
    align-items: center;
  }
`;
const PreviewCardStyles = (theme) => css `
  border-radius: ${theme.border_radius.sm};
`;
const DetailCardStyles = (theme) => css `
  border-radius: ${theme.border_radius.sm};
`;
const AssistantCardStyles = (theme) => css `
  background: ${theme.colors.beige_1};
`;
const SmallCardStyles = (type, theme) => css `
  ${GrantCardHeaderInfos} {
    gap: ${theme.spacing.sm}px;
  }

  ${GrantCardHeaderContainer} {
    padding-block-start: ${type === 'preview'
    ? theme.spacing.md
    : theme.spacing.lg}px;
    padding-block-end: ${theme.spacing.md}px;
    padding-inline-start: ${theme.spacing.md}px;
    padding-inline-end: ${type === 'preview'
    ? theme.spacing.md
    : theme.spacing.lg}px;
    gap: ${theme.spacing.md}px;
  }

  ${GrantCardBodyContainer} {
    padding-inline: ${theme.spacing.md}px;
    padding-block: 0;
  }

  ${GrantCardInfosBoxContainer} {
    gap: ${theme.spacing.xs}px;
  }
  ${GrantCardInfosBoxBody} {
    padding-inline-start: calc(
      ${SmallBodyTheme.iconSize}px + ${theme.spacing.sm}px
    );
  }

  ${media.l `
      ${GrantCardBodyContainer} {
        padding-inline:0;
      }
    `}
`;
const LargeCardStyles = (type, theme) => css `
  ${GrantCardHeaderInfos} {
    gap: ${theme.appearance.spacing}px;
  }

  ${GrantCardHeaderContainer} {
    padding-block-start: ${type === 'preview'
    ? theme.spacing.md
    : theme.spacing.lg}px;
    padding-block-end: ${theme.spacing.md}px;
    padding-inline-start: ${theme.spacing.md}px;
    padding-inline-end: ${type === 'preview'
    ? theme.spacing.md
    : theme.spacing.lg}px;

    gap: ${theme.appearance.spacing * 5}px;
  }

  ${GrantCardBodyContainer} {
    padding-inline: ${theme.spacing.md}px;
    padding-block: 0;
  }
  ${GrantCardInfosBoxContainer} {
    gap: ${theme.spacing.sm}px;
  }
  ${GrantCardInfosBoxBody} {
    padding-inline-start: calc(
      ${LargeBodyTheme.iconSize}px + ${theme.spacing.sm}px
    );
  }

  ${media.l `
    ${GrantCardBodyContainer} {
      padding-inline:0;
    }
    `}
`;
const GrantCardHoverableStyles = (theme) => css `
  &:hover {
    box-shadow: ${theme.appearance.box_shadow_hover};
    transform: translateY(-4px);
    cursor: pointer;
    color: ${theme.colors.primary};
  }
`;
export const GrantCardContainer = styled.div `
  display: block;
  box-shadow: ${({ theme }) => theme.appearance.box_shadow};
  border: ${({ $type }) => ($type === 'assistant' ? 'none' : '1px solid')}
    ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.beige_3};
  ${({ $type, theme }) => $type === 'preview'
    ? PreviewCardStyles(theme)
    : $type === 'assistant'
        ? AssistantCardStyles(theme)
        : DetailCardStyles(theme)};

  ${({ $size, $type, theme }) => $size === 'small'
    ? SmallCardStyles($type, theme)
    : LargeCardStyles($type, theme)}

  ${GrantCardHeaderContainer} {
    align-items: center;
  }

  ${({ $hoverable, theme }) => $hoverable && GrantCardHoverableStyles(theme)}

  .box {
    .content {
      font-size: ${({ theme }) => theme.fonts.body2};
      line-height: ${({ theme }) => theme.fontsLineHeights.body2};
    }
  }

  ${media.l `
    ${GrantCardHeaderContainer} {
      align-items: center;
      justify-content: center;
      gap: ${({ theme }) => theme.spacing.md}px;
    }
  `}
`;
export const GrantCardBodyContainer = styled.div `
  border-top: 1px solid ${({ theme }) => theme.colors.grey_4};
`;
export const GrantCardInfosBoxContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding-inline: ${({ theme }) => theme.spacing.md}px;
  padding-block: ${({ theme }) => theme.spacing.sm}px;

  border-right: 1px solid ${({ theme }) => theme.colors.grey_4};

  &:last-child {
    border-right: none;
  }

  ${media.l `
    padding-inline:0;
    `}
`;
export const GrantCardBodyContent = styled.div `
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  width: 100%;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}px) {
    grid-template-columns: repeat(1, 1fr);
    padding-inline: 0;
    ${GrantCardInfosBoxContainer} {
      border-right: none;
      padding-inline: ${({ theme }) => theme.spacing.md}px;
      border-bottom: 1px solid ${({ theme }) => theme.colors.grey_4};
    }
  }
`;
export const GrantCardHeaderInfos = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}px;
  width: 100%;

  ${({ $withNotifications, theme }) => $withNotifications &&
    css `
      padding-inline-end: ${theme.spacing.lg}px;
    `}

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}px) {
    align-items: center;
    text-align: center;
    .description {
      text-align: center;
    }
    padding-inline-end: 0;
  }
`;
export const GrantCardHeading = styled.div `
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm}px;
  justify-content: space-between;
  align-items: flex-start;

  &:hover {
    text-decoration: underline;
  }
`;
export const GrantCardProviderList = styled.div `
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}px;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    justify-content: center;
  }
`;
export const GrantCardInfosBoxBody = styled.div `
  width: 100%;
  ul {
    margin: 0;
    padding-inline-start: 0;
    li {
      margin-block-start: 0;
      margin-block-end: ${({ theme }) => theme.appearance.spacing * 0.5}px;
      padding-inline-start: 0;
    }
  }
`;
export const GrantCardProvider = styled(Typography) `
  color: ${({ theme }) => theme.colors.purple_2};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.purple_1};
    text-decoration: underline;
  }
`;
export const StyledCollapse = styled(Collapse) `
  .ant-collapse-item > .ant-collapse-header {
    padding: 0 16px 0 0;
    background-color: ${({ theme }) => theme.colors.beige_1};
  }
  .ant-collapse-item > .ant-collapse-content {
    background-color: transparent;
  }
  .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
    padding: 0;
    padding-block: 0;
  }
`;
